<template>
  <div class="row">
    <div class="col-md-12">
      <div class="text-center">
        <a href="#!" class="btn btn-primary btn-lg" @click="addToCart">zum Warenkorb</a>
      </div>
      <br>
      <div class="text-center">
        <a href="#!" class="btn btn-outline-primary" @click="showRequestForm">Unverbindliche Anfrage</a>
        <a href="#!" class="btn btn-outline-primary" @click="printed()">Konfiguration ausdrucken</a>
        <a href="https://www.loewe-zaun.de/prospekte" class="btn btn-outline-primary" target="_blank">Prospekt anfordern</a>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Zusammen',
  computed: {
    ...mapGetters({
      step: 'configurator/currentStep',
      summary: 'configurator/summary'
    })
  },
  methods: {
    ...mapActions({
      addItem: 'checkout/addItem',
      showRequestForm: 'configurator/showRequestForm'
    }),
    addToCart () {
      this.addItem(this.summary)
      this.$router.push({ name: 'checkout.overview' })
    },
    printed () {
      const p = document.getElementById('print-content')
      const configData = btoa(JSON.stringify(this.summary))
      const qs = require('qs')
      axios.post('/configurator/print', qs.stringify({ config: configData })).then((resp) => {
        p.innerHTML = resp.data
        setTimeout(function () {
          window.print()
        }, 1000)
      })
    }
  }
}
</script>
